import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { prefersReducedMotion } from './gsapSetup';

const variants = {
  initial: { opacity: 0, y: 18 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    opacity: 0,
    y: -12,
    transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
  },
};

const reduced = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
};

const PageTransition = ({ children }) => {
  const location = useLocation();
  const reduce = prefersReducedMotion();

  return (
    <motion.div
      key={location.pathname}
      className="page-transition"
      variants={reduce ? reduced : variants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
